import React from "react";

const VanRentalSteps = ({ title, description, steps }) => {
  return (
    <section className="vr-steps-section">
      <div className="container">
        <div
          className="text-center mb-5"
          data-aos="fade-up"
          data-aos-once="true"
        >
          <h2>{title}</h2>
          {description && <p>{description}</p>}
        </div>

        <div className="row g-4 justify-content-center">
          {steps.map((step, i) => (
            <div
              key={i}
              className="col-sm-6 col-lg-4"
              data-aos="fade-up"
              data-aos-delay={`${(i % 3) * 100}`}
              data-aos-duration="700"
              data-aos-once="true"
            >
              <div className="vr-step-card">
                <span className="vr-step-number">{String(i + 1).padStart(2, "0")}</span>
                <i className={`bi ${step.icon} vr-step-icon`}></i>
                <p className="vr-step-title">{step.title}</p>
                <p className="vr-step-desc">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default VanRentalSteps;
